import { useState } from 'react';
import { addDoc, collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../context/AuthContext';

const MONTHLY_PRICE_ID = 'price_monthly_xxx'; // ← replace with real Stripe price ID
const ANNUAL_PRICE_ID  = 'price_annual_xxx';  // ← replace with real Stripe price ID

export default function UpgradePrompt({ onClose }) {
  const { user }   = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  const checkout = async (priceId) => {
    setLoading(true);
    setError(null);
    try {
      const ref = await addDoc(
        collection(db, `customers/${user.uid}/checkout_sessions`),
        {
          price: priceId,
          success_url: window.location.origin + '/?checkout=success',
          cancel_url:  window.location.origin + '/?checkout=canceled',
        }
      );
      onSnapshot(ref, (snap) => {
        const { error: stripeError, url } = snap.data() || {};
        if (stripeError) { setError(stripeError.message); setLoading(false); }
        if (url) window.location.assign(url);
      });
    } catch (e) {
      setError(e.message);
      setLoading(false);
    }
  };

  const overlay = { position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center' };
  const box = { background:'var(--navy-mid)', border:'1px solid var(--border)', borderRadius:'12px', padding:'32px', maxWidth:'420px', width:'90%', display:'flex', flexDirection:'column', gap:'16px' };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={box} onClick={e => e.stopPropagation()}>
        <div style={{ fontSize:'1.3rem', fontWeight:700, color:'var(--gold)' }}>Upgrade to LPODASH Pro</div>
        <div style={{ fontSize:'0.9rem', color:'var(--text-secondary)' }}>
          Unlimited sailors, quals tracking, personnel profiles, awards, eval builder, and read-only leadership share links.
        </div>
        {error && <div style={{ color:'var(--danger)', fontSize:'0.85rem' }}>{error}</div>}
        <button
          disabled={loading}
          onClick={() => checkout(MONTHLY_PRICE_ID)}
          style={{ background:'var(--gold)', color:'#000', border:'none', borderRadius:'8px', padding:'12px', fontWeight:700, fontSize:'0.95rem', cursor: loading ? 'not-allowed' : 'pointer' }}>
          {loading ? 'Redirecting...' : '$9.99 / month'}
        </button>
        <button
          disabled={loading}
          onClick={() => checkout(ANNUAL_PRICE_ID)}
          style={{ background:'transparent', color:'var(--gold)', border:'1px solid var(--gold)', borderRadius:'8px', padding:'12px', fontWeight:700, fontSize:'0.95rem', cursor: loading ? 'not-allowed' : 'pointer' }}>
          {loading ? 'Redirecting...' : '$99 / year  (save 17%)'}
        </button>
        <button onClick={onClose} style={{ background:'none', border:'none', color:'var(--text-secondary)', fontSize:'0.85rem', cursor:'pointer' }}>
          Maybe later
        </button>
      </div>
    </div>
  );
}
